import { DateRangeFormPickerWrapper } from '@components/CalendarDateRange';
import { ControlledTextInput } from '@components/ControlledTextInput';
import { FiltersModal } from '@components/FiltersModal/FiltersModal';
import { useClearFilter } from '@hooks/useClearFilter.ts';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export interface AccountDetailFilters {
	dateFrom?: string;
	dateTo?: string;
	beneficiary?: string;
	paymentDescription?: string;
}

interface AccountDetailFilterProps {
	onApply: (filters: AccountDetailFilters) => void;
}

export const AccountDetailFilter = ({ onApply }: AccountDetailFilterProps) => {
	const { t } = useTranslation('', { keyPrefix: 'filters' });
	const filterForm = useFormContext<AccountDetailFilters>();
	const { control, handleSubmit } = filterForm;
	const { hasFilters, handleClear } = useClearFilter(filterForm, onApply);

	return (
		<FiltersModal
			hasFilters={hasFilters}
			onClear={handleClear}
			onSubmit={handleSubmit(onApply)}
		>
			<DateRangeFormPickerWrapper control={control} disabledFuture />
			<ControlledTextInput label={t('beneficiary')} name="beneficiary" />
			<ControlledTextInput label={t('paymentDescription')} name="paymentDescription" />
		</FiltersModal>
	);
};
